import { CommonActivitySearchTile } from './CommonActivitySearchTile';
import { OngoingActivitySearchTile } from './OngoingActivitySearchTile';

export const ActivitySearchTile = {
  Common: CommonActivitySearchTile,
  Ongoing: OngoingActivitySearchTile,
};
